export const initImageInDonutHeight = () => {
	const donutCardImageSVG = document.querySelectorAll<HTMLElement>(".animated-donut-image");
	if (donutCardImageSVG.length) {
		[...donutCardImageSVG].forEach((donutCardImage) => {
			const img = donutCardImage.querySelector("img");
			if (img) {
				donutCardImage.style.height = `${img.clientWidth}px`;
				donutCardImage.style.opacity = "1";
				const donutCardImageCover = donutCardImage.querySelector<HTMLElement>(
					".animated-donut-image-cover"
				);
				if (donutCardImageCover) donutCardImageCover.style.height = `${img.clientWidth}px`;
			}
		});
	}
};
